import { defineNuxtRouteMiddleware, useNuxtApp, useRoute } from 'nuxt/app'
import { setLocale, getLocale } from '~/plugins/i18n/persistLocale'

export const handleLocale = () => {
  const nuxtApp = useNuxtApp()
  const route = useRoute()
  const { $i18n } = nuxtApp

  // Check for locale query parameter
  const localeParam = route.query.locale
  if (localeParam) {
    // Check if the locale parameter is a valid/supported locale
    const availableLocales = $i18n.locales.map((locale: Locale) => locale.code)

    if (availableLocales.includes(localeParam)) {
      setLocale($i18n, localeParam)
      return
    }
  }

  // Fall back to stored locale if no valid locale parameter
  const storedLocale = getLocale()
  if (storedLocale !== null) {
    setLocale($i18n, storedLocale)
  }
}

export default defineNuxtRouteMiddleware(handleLocale)
